module.exports = __webpack_public_path__ + "static/media/down-bold-red.4b50ac2c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/down-bold-red.svg
// module id = ./src/assets/icons/down-bold-red.svg
// module chunks = 0